import React, { FC } from "react";

import Button from "../../../../../components/elements/Button";
import api from "../../../../../api";
import classes from "../../CampaignsDashboard.module.scss";
import { successToaster } from "../../../../../helpers/toasters";

type CopyTrackingPixelButtonProps = {
  pixelEventId: number;
};

async function safeWriteToClipboard(text: string) {
  const hasClipboardApi =
    typeof navigator !== "undefined" && !!navigator.clipboard && typeof navigator.clipboard.writeText === "function";

  if (hasClipboardApi && typeof document !== "undefined" && document.hasFocus()) {
    await navigator.clipboard.writeText(text);
    return;
  }

  if (typeof document === "undefined") return;
  const textarea = document.createElement("textarea");
  textarea.value = text;
  textarea.setAttribute("readonly", "");
  textarea.style.position = "fixed";
  textarea.style.top = "-9999px";
  textarea.style.left = "-9999px";
  document.body.append(textarea);
  textarea.select();
  document.execCommand("copy");
  textarea.remove();
}

const CopyTrackingPixelButton: FC<CopyTrackingPixelButtonProps> = ({ pixelEventId }) => {
  const handleClick = async () => {
    if (!pixelEventId) {
      return;
    }
    const { payload } = await api.getConversionPixel(pixelEventId);

    try {
      await safeWriteToClipboard(payload);
      successToaster("Tracking Pixel is copied to clipboard!", 5000);
    } catch (error_) {
      const error = error_ as any;
      if (error?.name === "NotAllowedError") {
        return;
      }
      throw error_;
    }

    // navigator.clipboard.writeText(`<code>
    //   &lt;!--BEGIN CONVERSION TAG, DO NOT REMOVE --&gt; &lt;script&gt; var cachebuster =
    //   Math.floor(Math.random() * 10000000000); var img = new Image(); img.width = 0; img.height = 0; img.src
    //   = 'https://cnv.event.prod.bidr.io./log/cnv?tag_id=${pixelEventId}
    //   &buzz_key=brandgen&value=[VALUE]&segment_key=${pixelEventId}
    //   &order=[ORDER]&ord=' + cachebuster; document.body.appendChild(img); //can be modified to
    //   wherever you want the image added/appended &lt;/script&gt; &lt;!--END CONVERSION TAG, DO NOT REMOVE
    //   --&gt;
    // </code>`
    // );
  };

  return (
    <div className={classes.copyTrackingPixelContiner}>
      <div className={classes.copyTrackingPixel}>
        <Button variant="contained" onClick={handleClick}>
          Copy Conversion Pixel
        </Button>
      </div>
    </div>
  );
};

export default CopyTrackingPixelButton;
